// Request-local transport fence; account/generation authority stays with the
// existing launch operation. No persisted token, listener, timer, or new owner.
const guardKey = 'gameLaunchRequestCurrent';
const staleRequest = () => Object.assign(new Error('stale_game_launch'), { code: 'GAME_LAUNCH_STALE' });

export const assertGameLaunchRequestCurrent = request => {
  const guard = request?.[guardKey];
  if (guard && !guard(request)) throw staleRequest();
};

export const captureGameLaunchRequest = ({ params, getToken, isCurrent = () => true, getAdapter }) => {
  const token = getToken();
  const current = request => Boolean(token && isCurrent() && getToken() === token &&
    (request.headers?.get?.('Authorization') || request.headers?.Authorization) === `Bearer ${token}`);
  const assertCaptured = request => {
    if (request?.[guardKey] !== current || !current(request)) throw staleRequest();
  };
  const captured = {
    params,
    headers: { Authorization: `Bearer ${token}` },
    [guardKey]: current,
  };
  assertCaptured(captured);
  return {
    ...captured,
    adapter: async request => {
      // Axios has merged headers and completed every async interceptor now.
      assertCaptured(request);
      try {
        const response = await getAdapter()(request);
        assertCaptured(request);
        return response;
      } catch (error) {
        assertCaptured(request);
        throw error;
      }
    },
  };
};
